module.exports = __webpack_public_path__ + "static/media/10.daae5ae4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/10.jpg
// module id = 1742
// module chunks = 0